import { includes, keys, map, pickBy, reduce } from 'lodash';

export const getDefaultMeetingShares = ({
  meetingShares,
  meetingBoardMeetingShareIds
}) =>
  reduce(
    map(meetingShares, 'meeting_share_id'),
    (result, value) => {
      result[value] = includes(meetingBoardMeetingShareIds, value);

      return result;
    },
    {}
  );

export const getNewSelectedMeetingShares = ({
  meetingShares,
  meetingBoardMeetingShareIds
}) =>
  keys(
    pickBy(
      meetingShares,
      (value, key) =>
        !includes(meetingBoardMeetingShareIds, parseInt(key)) && value === true
    )
  );
